<a
  class="btn btn-lg"
  [appStoryblok]="_editable"
  [storyblokLink]="link"
  [ngClass]="[style]"
>
  {{ text }}
</a>
